/** Roles that use school-wide student lists (ignore admin.class_ scoping). */
export const FINANCE_FULL_STUDENT_ACCESS_ROLES = Object.freeze([
  'Accountant',
  'Finance Officer',
]);

/** Canteen staff: school-wide student list for canteen + students pages only (not full finance). */
export const CANTEEN_COLLECTOR_ROLE = 'Canteen Collector';

function titleIndicatesFinanceRole(positiondescription) {
  if (positiondescription == null || positiondescription === '') return false;
  const normalized = String(positiondescription).trim().toLowerCase();
  if (
    FINANCE_FULL_STUDENT_ACCESS_ROLES.some((role) => role.toLowerCase() === normalized)
  ) {
    return true;
  }
  return (
    normalized.includes('accountant') || normalized.includes('finance officer')
  );
}

function truthyAlsoAccountant(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * School-wide student/canteen/fees access.
 * Pass the logged-in `admin` object (recommended), or a `positiondescription` string.
 */
export function hasFinanceFullStudentAccess(adminOrPositionDescription) {
  if (
    adminOrPositionDescription != null &&
    typeof adminOrPositionDescription === 'object' &&
    !Array.isArray(adminOrPositionDescription)
  ) {
    const admin = adminOrPositionDescription;
    if (truthyAlsoAccountant(admin.alsoAccountant)) return true;
    return titleIndicatesFinanceRole(admin.positiondescription);
  }
  return titleIndicatesFinanceRole(adminOrPositionDescription);
}

/** True when role is Canteen Collector (students + canteen scope). */
export function hasCanteenCollectorAccess(adminOrPositionDescription) {
  if (
    adminOrPositionDescription != null &&
    typeof adminOrPositionDescription === 'object' &&
    !Array.isArray(adminOrPositionDescription)
  ) {
    const pd = adminOrPositionDescription.positiondescription;
    return String(pd || '').trim() === CANTEEN_COLLECTOR_ROLE;
  }
  return String(adminOrPositionDescription || '').trim() === CANTEEN_COLLECTOR_ROLE;
}

/**
 * School-wide student list: finance roles, also-accountant flag, or Canteen Collector.
 * Use on Students page and Canteen page; keep Finance menu on hasFinanceFullStudentAccess only.
 */
export function hasSchoolWideStudentListAccess(adminOrPositionDescription) {
  return (
    hasFinanceFullStudentAccess(adminOrPositionDescription) ||
    hasCanteenCollectorAccess(adminOrPositionDescription)
  );
}
